/**
 * authContext.js — the context AuthProvider fills and useAuth() reads (2026-09-24).
 * Kept apart from AuthProvider.jsx so that file exports only a component
 * (react-refresh/only-export-components).
 */
import { createContext, useContext } from 'react';

// status: 'off'      VITE_AUTH_MODE=off — no sign-in, the app renders as before
//         'loading'  first /session answer not in yet
//         'ok'       signed in; user is set
//         'unauth'   the gate said 401 (a redirect to login is under way, or was
//                    suppressed by the 30 s loop guard — the menu then offers "Sign in")
//         'unknown'  the gate could not be asked (offline, gate down); nothing changes
export const OFF_AUTH = Object.freeze({
  status: 'off',
  user: null,
  perms: Object.freeze([]),
  signOut: () => {},
  signIn: () => {},
  refresh: () => {},
});

export const AuthContext = createContext(OFF_AUTH);

export function useAuth() {
  return useContext(AuthContext);
}
